import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { DatePicker } from '@mui/x-date-pickers';
import { Box } from '@mui/material';
function ICDateInput(props) {
  const [selectedDate, setSelectedDate] = useState(
    props.defaultDate ? moment(props.defaultDate) : null
  );
  const handleChange = (newDate) => {
    setSelectedDate(newDate);
    props.handleChange(newDate ? newDate.toISOString() : '');
  };

  useEffect(() => {
    if (props.defaultDate && moment(props.defaultDate).isValid()) {
      setSelectedDate(moment(props.defaultDate));
    }
  }, [props.defaultDate]);

  return (
    <Box sx={{ width: 1 }} className={'ic-date-input ' + (props.className ? props.className : '')}>
      <DatePicker
        id={props.id}
        name={props.name}
        label={props.label}
        format="DD/MM/YYYY"
        value={selectedDate}
        onChange={(newDate) => handleChange(newDate)}
        disabled={props.disabled === true}
        slotProps={{
          textField: { error: props.error, fullWidth: true, helperText: props.helperText },
        }}
      />
    </Box>
  );
}

export default ICDateInput;
